(function () {
  var track, isFr, endAt, clock, countdownSlide, bigBar, bigUnits;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function expire() {
    if (countdownSlide && countdownSlide.parentNode) {
      countdownSlide.parentNode.removeChild(countdownSlide);
    }
    if (bigBar) { bigBar.style.display = 'none'; }
    clock = null;
    bigBar = null;
  }

  function tick() {
    var left = endAt - Date.now();
    if (left <= 0) { expire(); return false; }

    var d = Math.floor(left / 86400000);
    var h = Math.floor((left % 86400000) / 3600000);
    var m = Math.floor((left % 3600000) / 60000);
    var s = Math.floor((left % 60000) / 1000);

    if (clock) {
      if (d > 0) {
        clock.textContent = (isFr ? d + 'j ' : d + 'd ') + h + 'h ' + pad(m) + 'm';
      } else {
        clock.textContent = h + 'h ' + pad(m) + 'm ' + pad(s) + 's';
      }
    }
    if (bigUnits) {
      var v = { days: pad(d), hours: pad(h), mins: pad(m), secs: pad(s) };
      for (var k in v) {
        if (bigUnits[k] && bigUnits[k].textContent !== v[k]) { bigUnits[k].textContent = v[k]; }
      }
    }
    return true;
  }

  function rotate() {
    var current = 0;
    setInterval(function () {
      var messages = track.querySelectorAll('.lt-rotating-message');
      if (messages.length < 2) return;
      if (current >= messages.length) current = 0;
      messages[current].classList.remove('active');
      current = (current + 1) % messages.length;
      messages[current].classList.add('active');
    }, 3500);
  }

  function init() {
    track = document.getElementById('ltRotatingTrack');
    if (!track) return;

    isFr = track.getAttribute('data-fr') === 'true';
    endAt = new Date(track.getAttribute('data-promo-end')).getTime();
    clock = document.getElementById('ltClock');
    countdownSlide = document.getElementById('ltCountdownSlide');
    bigBar = document.getElementById('ltBcdBar');
    if (bigBar) {
      bigUnits = {
        days: bigBar.querySelector('[data-cd="days"]'),
        hours: bigBar.querySelector('[data-cd="hours"]'),
        mins: bigBar.querySelector('[data-cd="mins"]'),
        secs: bigBar.querySelector('[data-cd="secs"]')
      };
    }

    // The mobile hero advertises the free-knife saving, which is paused this week.
    // Correct it to the real tower discount and only then let it show.
    var saves = document.querySelectorAll('.lt-mhero__save');
    for (var i = 0; i < saves.length; i++) {
      saves[i].textContent = isFr ? 'Économisez 40 $' : 'Save $40';
      saves[i].classList.add('lt-promo-ready');
    }

    tick();
    setInterval(tick, 1000);
    rotate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
